import { render, staticRenderFns } from "./HumanFilterEdit.vue?vue&type=template&id=85d52350"
import script from "./HumanFilterEdit.vue?vue&type=script&lang=ts"
export * from "./HumanFilterEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports